/**
 * BLU-711 A2 number/date formatting helpers.
 *
 * Every figure on this surface is a unit count, so there is no currency here —
 * just locale thousands separators (DESIGN.md §17) and an explicit sign, since
 * "did stock go up or down" is the question the whole page answers.
 */
import { format } from 'date-fns';
import type { Locale } from 'date-fns/locale';
import { DATE_FORMAT, DATE_TIME_FORMAT } from '@/lib/format-dates';

/** `1204` -> "+1,204", `-880` -> "-880", `0` -> "0". */
export function formatSigned(value: number): string {
  if (value === 0) return '0';
  const sign = value > 0 ? '+' : '-';
  return `${sign}${Math.abs(value).toLocaleString()}`;
}

export function formatQty(value: number): string {
  return value.toLocaleString();
}

export function formatDate(iso: string | null, locale: Locale): string {
  if (!iso) return '';
  const parsed = new Date(iso);
  if (Number.isNaN(parsed.getTime())) return '';
  return format(parsed, DATE_FORMAT, { locale });
}

export function formatDateTime(iso: string | null, locale: Locale): string {
  if (!iso) return '';
  const parsed = new Date(iso);
  if (Number.isNaN(parsed.getTime())) return '';
  return format(parsed, DATE_TIME_FORMAT, { locale });
}
